<template>

    <div>

        <transition-group name="slide-fade" tag="div" class="grid-testimonials-text" v-if="selectedCategory == 'text'">

            <div
                    v-for="(post, index) in posts"
                    :key="index + 10"
                    class="item item-text"
                    :class="['item-' + ++index]"

            >

                <!-- Testimonial Text-->

                <div class="inner-wrap">

                    <div class="post-inner post-testimonial-text" v-if="post.post_content">
                        <div class="post-title">{{ post.post_title }}</div>

                        <div class="post-description">
                            {{post.post_content}}
                        </div>

                        <div v-if="post.client_name" class="post-name">– <span>{{post.client_name}}</span></div>

                    </div>

                </div>

            </div>

        </transition-group>
    </div>

</template>

<script>

    export default {
        data: function () {
            return {
                count: 123
            }
        },
        props: {
            posts: {
                type: Array
            },
            selectedCategory: {
                type: String
            }
        }
    }
</script>

<style lang="scss">

    .modal-testimonial-video {

        .modal-body {
            padding-top: 20px;
        }

    }

    .control {
        width: 200px;
        height: 100px;
        border: 6px solid #333;
        position: relative;
        display: flex;
    }

    .slide-fade-enter-active {
        transition: all 0.0s ease;
    }

    .slide-fade-leave-active {
        transition: all 0.0s ease;
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
        transition: all 0.0s ease;
    }
</style>